import React, { useEffect, useState } from 'react';
import EditDependentsPresenter from './EditDependentsPresenter';
import DTOEditDependents from './DTOEditDependents';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';

import toast from 'react-hot-toast';
import { dependentsServices } from '../../../../api/services/dependentsServices';
import { setAlldependentslist } from '../../../../infra/aggregates/myProfile/DependentsAggregates/dependentslistSlice';
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  editDepDocuments: any;
  mainModel: any;
  trans?: any;
}
const EditDependentsController = ({
  isModalOpen,
  closeModal,
  editDepDocuments,
  mainModel,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const [EmpDocTypes, setEmpDocTypes] = useState<[]>([]);
  const [countries, setCountries] = useState<[]>([]);
  const dispatch = useAppDispatch();

  const patchdata = (data: any) => {
    console.log({ Date: data });
    updateEmpDocs(data);
  };
  async function updateEmpDocs(data: any) {
    if (selector) {
      const empId: any = selector.emp_id;

      const formData: any = new FormData();
      formData.append('id', data.docId);
      formData.append('dependentId', editDepDocuments?.dependent_id);
      formData.append('empId', empId);
      formData.append('document_type_id', data.documentTypeId);
      formData.append('issue_country', data.countryName);
      formData.append('issue_date', data.issueDate);
      formData.append('validity_date', data.expiredDate);
      formData.append('identifier_number', data.identifierNo);
      formData.append('remarks', data.remarks);
      formData.append('removed', data?.removed);
      if (data?.newattachement) {
        formData.append('document[]', data.file);
      }
      formData.append('locale', localStorage.getItem('emplang'));
      const response: any = await dependentsServices.updateDepDocs(formData);
      if (response.response == 'success') {
        dispatch(setAlldependentslist(response.data));
        toast.success(trans('Updated Successfully'));
        mainModel(false);
      }
    }
  }
  async function callBack(data: []) {
    setCountries(data);
  }
  async function callBackEmptypes(data: []) {
    setEmpDocTypes(data);
  }
  return (
    <>
      <div>
        <DTOEditDependents
          setAllCountries={callBack}
          setAllEmpDocsType={callBackEmptypes}
        />
        <EditDependentsPresenter
          callBackData={patchdata}
          editDepDocuments={editDepDocuments}
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          allEmpDocTypes={EmpDocTypes}
          allCountires={countries}
          trans={trans}
        />
      </div>
    </>
  );
};
export default EditDependentsController;
